import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { device } from '../../../utils/constants';
import {
  LabBottomRule,
  labAos,
  labBodyMobile,
  labCaptionMobile,
  labSectionPadMobile,
  labTitleMobile,
} from './labShared';

const base = process.env.PUBLIC_URL || '';
const TITULOS_SRC = `${base}/img/lab/titulos.png`;
const PLATFORMS_SRC = `${base}/img/lab/platforms.png`;

const Section = styled.section`
  color: #ffffff;
  font-family: 'FuturaLigth';
  box-sizing: border-box;
  padding-top: 5vw;
  ${labSectionPadMobile}
`;

const MainTitle = styled.p`
  margin: 0;
  font-size: 4vw;
  font-weight: bold;
  color: white;
  font-family: 'MontserratBold';
  line-height: 0.4;
  ${labTitleMobile}

  @media ${device.mobile} {
    line-height: 1.1;
  }
`;

const SubTitleRow = styled.p`
  margin: 0;
  font-size: 4vw;
  font-weight: bold;
  color: white;
  font-family: 'MontserratBold';
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
  ${labTitleMobile}

  @media ${device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    margin-top: 0.25rem;
  }
`;

const TitleImg = styled.img`
  display: block;
  width: 100%;
  margin-top: clamp(1rem, 3vw, 1.5rem);
`;

const Credits = styled.span`
  margin: 0;
  font-size: 1.1vw;
  font-family: 'MontserratMedium';
  white-space: nowrap;
  ${labCaptionMobile}

  @media ${device.mobile} {
    white-space: normal;
    margin-top: 0.25rem;
  }
`;

const MidNote = styled.p`
  text-align: center;
  font-family: 'MontserratMedium';
  font-size: 1.2vw;
  margin: clamp(1.5rem, 4vw, 2rem) 0;
  ${labBodyMobile}
`;

const PlatformsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;

  @media ${device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

const PlatformsLabel = styled.span`
  font-size: 1.2vw;
  font-family: 'MontserratMedium';
  flex-shrink: 0;
  ${labBodyMobile}

  @media ${device.mobile} {
    margin-right: 0;
  }
`;

const PlatformsImg = styled.img`
  display: block;
  width: 75%;
  max-width: 100%;

  @media ${device.mobile} {
    width: 100%;
  }
`;

const BottomBlock = styled.div`
  padding-top: clamp(3rem, 8vw, 5rem);
  padding-bottom: clamp(1.25rem, 3vw, 2rem);

  @media ${device.mobile} {
    padding-top: clamp(2rem, 6vw, 3rem);
  }
`;

const VerticalLab = () => {
  const { t } = useTranslation();

  return (
    <Section aria-labelledby="lab-vertical-heading">
      <MainTitle id="lab-vertical-heading" {...labAos('fade-up')}>
        {t('lab.vertical.title')}
      </MainTitle>
      <SubTitleRow {...labAos('fade-up', 100)}>
        <span>{t('lab.vertical.productions')}</span>
        <Credits {...labAos('fade', 180)}>{t('lab.vertical.producedBy')}</Credits>
      </SubTitleRow>
      <TitleImg
        {...labAos('fade-up', 200)}
        src={TITULOS_SRC}
        alt={t('lab.vertical.productions')}
      />

      <MidNote {...labAos('fade-up', 280)}>{t('lab.vertical.plus')}</MidNote>

      <PlatformsRow {...labAos('fade-up', 360)}>
        <PlatformsLabel>{t('lab.vertical.platforms')}</PlatformsLabel>
        <PlatformsImg {...labAos('zoom-in', 420)} src={PLATFORMS_SRC} alt="" />
      </PlatformsRow>

      <BottomBlock>
        <LabBottomRule aria-hidden />
      </BottomBlock>
    </Section>
  );
};

export default VerticalLab;
